/**
 * Parses a value that may be JSON - including JSON that was stringified more than once
 * ("\"{...}\"") - and returns the parsed result. Anything that isn't valid JSON is returned
 * unchanged.
 */
export const parseIfJson = (data) => {
	try {
		const v = JSON.parse(data);
		return typeof v === "string" ? parseIfJson(v) : v;
	} catch {
		return data;
	}
};
